export class Observation {
  public OrderObservations: OrderObservation[];
  public PatientObservations: PatientObservation[];
  public AuditoriaObservations: AuditoriaObservation[];
}

export class OrderObservation {
  public Id: number;
  public Observation: string;
  public CreateUserName: string;
  public CreateDate: string;
  public CreateUserId: number;
  public OrderId: number;
}



export class AuditoriaObservation {
  public Id: number;
  public Observation: string;
  public CreateUserName: string;
  public CreateDate: string;
  public CreateUserId: number;
  public MedicalAppointmentId: number;
}


export class PatientObservation {
  public Id: number;
  public Observation: string;
  public CreateUserName: string;
  public CreateDate: string;
  public CreateUserId: number;
  public OrderId?: number;
  public PatientId: number;
}
